<template>
  <div>
    <vs-card class="p-4">
      <!-- Popup -->
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <!-- Title -->
          <div class="vx-col w-full mb-2">
            <vs-input icon-pack="feather" class="w-full" v-validate="'required|exclude_special_char'" v-model="form.title" label="Title *" placeholder="Notification Title" name="Title" id="title" />
            <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
          </div>

          <!-- Body -->
          <div class="vx-col w-full mb-2">
            <label class="vs-input--label block" for="body">Body *</label>
            <vs-textarea
              placeholder="Notification Description"
              class="w-full input mb-0"
              id="body"
              v-validate="'required|exclude_special_char'"
              name="body"
              v-model="form.body"
              :rows="6"
              data-vv-as="Body"
            />
            <span class="text-danger text-sm" v-show="errors.has('body')">{{ errors.first('body') }}</span>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 mt-12 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="send-notification" @click="save_changes">Send Notification</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: `Notification`,

  /** data */
  data() {
    return {
      form: {
        title: null,
        body: null
      }
    }
  },
  /** computed */
  computed: {
    ...mapState('setting', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    }
  },

  /** methods */
  methods: {
    ...mapActions('setting', {
      sendNotification: 'sendNotification'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const { message } = await this.sendNotification(this.form)
        // Clear form
        this.form.title = null
        this.form.body = null
        this.$validator.reset()

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#send-notification',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#send-notification > .con-vs-loading')
      }
    }
  }
}
</script>
